import { isFundingMethod } from '../discovery/policy.js';
/** Unknown historical methods are displayable, but cannot re-enter execution. */
export function fundingOperationForCheckout(operation) {
    if (operation.withdrawal)
        throw new Error('onramp_direction_mismatch');
    if ('exchangeSource' in operation ||
        'cryptoDepositSource' in operation ||
        'connectedWalletSource' in operation)
        throw new Error('method_unavailable');
    if (!isFundingMethod(operation.method))
        throw new Error('method_unavailable');
    return { ...operation, method: operation.method, withdrawal: null };
}
